import PropTypes from 'prop-types';
import React from 'react';
import DataService from '../../lib/DataService';
import InfiniteScroll from 'react-infinite-scroller';
import Utils from "./ClockUtils";
import { Modal, message, Avatar, Card, Icon, Spin } from "antd";
import { hashHistory, Link } from 'react-router';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import PostsList from './../album/PostsList';
import Slider from "react-slick";

const { Meta } = Card;
let POSTS_LIMIT_PER_PAGE = 10;

export default class ClockIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired, // this is passed from the Rails div
  };

  /**
   * @param props - Comes from your rails div.
   */
  constructor(props) {
    super(props);

    this.state = {
      taskId: props.params.taskId,
      year: props.location.query.year,
      month: props.location.query.month,
      day: props.location.query.day,
      students: [],
      supplementCount: 0,
      absentCount: 0,

      studentPosts: [],
      attendances: [],
      userRoleInfo: CurrentRoleStore.getCurrentRole(),
      hasMore: true,
      days: [],
      navIndex: 0,
      loading: false,

      update: false
    };
  }

  componentDidMount() {
    this.getAttendanceInfo(true);
    this.getDailyAttendances();
  }

  getAttendanceInfo(update) {
    this.setState({
      loading: true
    })
    let { taskId, year, month, day } = this.state;
    let formData = {
      id: taskId,
      year,
      month,
      day
    }

    DataService.getAttendanceInfo(formData).then((res) => {
      let students = res.daily_students_info, days = res.days_info;
      let supplementCount = 0, absentCount = 0;
      let index = days.findIndex(item => item.year == year && item.month == month && item.day == day);
      let count = parseInt(days.length / 10) + (days.length % 10 > 0 ? 1 : 0);

      if (update) {
        this.setState({
          students: res.daily_students_info,
          supplementCount,
          absentCount,
          days,
          update: true,
          navIndex: parseInt(index / 10) * 10,
          loading: false
        })
      } else {
        this.setState({
          students: res.daily_students_info,
          supplementCount,
          absentCount,
          days,
          loading: false
        })
      }
    }).catch((error) => {
      console.log(error);
      this.setState({
        loading: false
      })
    });

  }

  getDailyAttendances(to_id) {
    let { taskId, year, month, day, studentPosts, attendances} = this.state;
    let data = {
      task_id: taskId,
      year,
      month,
      day,
    }
    if (to_id) {
      data.to_id = to_id;
    }
    DataService.getDailyAttendances(data).then((result) => {
      let res = result.map(item => item.post), items = result.map(item => {
        return {
          attendance_day: item.attendance_day,
          attendance_month: item.attendance_month,
          attendance_year: item.attendance_year,
          post_id: item.post_id,
          id: item.id,
        }
      });

      if (!to_id){
        studentPosts = [];
        attendances = [];
      }
      
      studentPosts = studentPosts.concat(res);
      attendances = attendances.concat(items);

      this.setState({
        studentPosts,
        attendances,
        hasMore: false
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  attendanceRemind() {
    let { taskId, year, month, day } = this.state;
    let data = {
      id: taskId,
      year,
      month,
      day
    }
    DataService.attendanceRemind(data).then((res) => {
      message.success('已提醒家长')
    }).catch((error) => {
      console.log(error);
      message.error('提醒失败')
    });
  }

  // Events
  onUserRoleChange() {
    this.setState({
      userRoleInfo: CurrentRoleStore.getCurrentRole()
    });
  }

  onScrollToBottom(page) {
    if (this.state.hasMore)
      this.getDailyAttendances();
  }

  onDestroyPost(postId) {
    let index = this.state.studentPosts.findIndex((post) => post.id === postId);
    if (index >= 0) {
      this.state.studentPosts.splice(index, 1);
      this.setState({
        studentPosts: this.state.studentPosts
      });
    }
  }

  updatePosts(postId) {
    let posts = this.state.studentPosts;
    posts = posts.filter(function (post) {
      return post.id != postId
    })
    this.setState({
      studentPosts: posts
    })
  }

  changeDate(item) {
    let {year, month, day} = item;
    this.setState({
      year,
      month,
      day
    }, () => {
        this.getAttendanceInfo()
        this.getDailyAttendances();
    })
  }

  // 切换日期
  _changeDateView() {
    let { days, update, count, year, month, day } = this.state;
    let arr = [];
    for (let index = 0; index < count; index++) {
      const items = days.slice(index * 10, (index + 1) * 10);
      arr.push(items)
    }
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 10,
      slidesToScroll: 10,
      // asNavFor: this.state.navIndex,
      beforeChange: function (currentSlide, nextSlide) {
        console.log('before change', currentSlide, nextSlide);
      },
      afterChange: (currentSlide) => {
        if (update) {
          this.slider.slickGoTo(this.state.navIndex)
          this.setState({
            update: false
          })
        }
      },
    };
    return (
      <div className="slick-container">
        <div className="slick-content" ref="slider">
          <Icon type="caret-left" onClick={this.previous} className="caret-left caret-icon" />
          <Icon type="caret-right" onClick={this.next} className="caret-right caret-icon" />
          <Slider {...settings} ref={slider => (this.slider = slider)}>
            {days.map((item, index) => <div key={index} className="circle-container" onClick={() => this.changeDate(item)}>
              <div className="circle-detail">
                <div className={"circle" + (item.year == year && item.month == month && item.day == day ? " selected" : "")}>
                  <div className="circle-label">{item.day}</div>
                  <div>{Utils.getMonthString(item.month)}</div>
                </div>
              </div>
            </div>)}
          </Slider>
        </div>
      </div>
    )
  }

  // 打卡学生详情
  _taskItemView() {
    let {students} = this.state;
    return (
      <div className="card-item task-detail clock-content">
        <div className="card-label">
          已打卡{students.filter(s => s.is_attendance).length}人其中补卡{students.filter(s => s.is_supplement).length}人，未打卡{students.filter(s => !s.is_attendance && !s.is_supplement).length}人 
          <a className="remind-btn" onClick={() => this.attendanceRemind()}>一键提醒未打卡家长</a>
        </div>
        <div className="students-list">
          {students.map(item => <div className="student-item" key={item.student.id}>
            <div>{item.student.full_name}</div>
            <div className={!item.is_attendance ? 'status attendance' : 'status'}>{item.is_supplement ? '补卡' : (item.is_attendance ? '已打卡' : '-')}</div>
          </div>)}
        </div>
      </div >
    )
  }

  _postsListView() {
    let loaderDom = <div className="scroll-loader">正在读取打卡信息 ...</div>;
    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={() => this.onScrollToBottom}
        hasMore={this.state.hasMore}
        loader={loaderDom}
        useWindow={true}
      >
        <PostsList posts={this.state.studentPosts} type={'albumPost'} userRoleInfo={this.state.userRoleInfo} onDestroyPost={() => this.onDestroyPost()} updatePosts={() => this.updatePosts()} />

        {!this.state.hasMore && this.state.studentPosts.length > 0 && <div className="no-more-scroll">没有更多打卡信息了</div>}
        {!this.state.hasMore && this.state.studentPosts.length <= 0 && <div className="no-posts" style={{marginTop: '20px'}}>暂无打卡信息</div>}
      </InfiniteScroll>
    );
  }

  render() {
    let { task, students, absentStudents, loading } = this.state;
    return (
      <Spin tip="加载中..." spinning={loading}>
        <div className="clock-index-page posts-index-page">
          <div className="card-list">
            {this._changeDateView()}
            {this._taskItemView()}
            {this._postsListView()}
          </div>
        </div >
      </Spin>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/clock/ClockContent.jsx